import { useEffect, useState } from "react";
import { Bien } from "../../model/Model";
import { ajouterBien, getBiens, modifierBien, supprimerBien } from "../../service/biens/biens.service";
import { AjouterBienPopup } from "./AjouterBien";

function Biens(){

   const [biens, setBiens] = useState<Bien[]>([]);
   const [seen, setSeen] = useState(false);
   const [bienId, setBienId] = useState<number | undefined>(undefined);
   const [menuOpen, setMenuOpen] = useState<number | null>(null);

   useEffect(() => {
     async function fetchData() {
       const data = await getBiens();
       console.log(data);
       setBiens(data);
     }
     fetchData();
   }, []);

   // Fermer le menu quand on clique en dehors
   useEffect(() => {
     const handleClickOutside = () => {
       if (menuOpen !== null) {
         setMenuOpen(null);
       }
     };
     
     document.addEventListener('click', handleClickOutside);
     return () => {
       document.removeEventListener('click', handleClickOutside);
     };
   }, [menuOpen]);


    function togglePopup() {
        setSeen(!seen);
        setBienId(undefined);
    };

    
    const closePopup = () => {
        setSeen(false);
        setBienId(undefined);
    };


    async function ajouterModifier(bien:Bien): Promise<void> {
        try{
            if(bien.bienId){
                await modifierBien(bien);
            }else{
                await ajouterBien(bien);
            }
        }catch(error){
            console.log(error)
        }finally{
            const biens = await getBiens();
            setBiens(biens);
            setSeen(false);
        }  
    }

    async function handleSupprimer(id: number | undefined) {
        if (id === undefined) return;
        try {
            await supprimerBien(id);
            const biens = await getBiens();
            setBiens(biens);
        } catch (error) {
            console.log(error);
        }
    }

        function handleModifier(id: number | undefined) {
            setBienId(id);
        setSeen(true);
    }

    const toggleMenu = (id: number | undefined) => {
        if (id !== undefined) {
            setMenuOpen(menuOpen === id ? null : id);
        }
    };

    const handleMenuClick = (e: React.MouseEvent, id: number | undefined) => {
        e.stopPropagation();
        toggleMenu(id);
    };

    return(
        <div className="pt-6 bg-gray-50 min-h-screen">
            <div className="max-w-7xl mx-auto">
                <div className="mb-6">
                    <button 
                        onClick={togglePopup}
                        className="bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-4 rounded-lg transition duration-200 ease-in-out transform hover:scale-105 shadow-md"
                    >
                        + Ajouter un bien
                    </button>
                    {seen ? <AjouterBienPopup bienId={bienId} ajouterModifier={ajouterModifier} onClose={closePopup}/> : null}
                </div>

                <div className="bg-white rounded-lg shadow-lg overflow-hidden">
                    <div className="px-6 py-4 bg-gray-50 border-b border-gray-200">
                        <h2 className="text-xl font-semibold text-gray-800">Liste des biens</h2>
                    </div>
                    
                    {biens?.length > 0 ? (
                        <div className="overflow-x-auto pb-20">
                            <table className="w-full">
                                <thead className="bg-gray-50">
                                    <tr>
                                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                            Identifiant
                                        </th>
                                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                            Adresse
                                        </th>
                                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                            Ville
                                        </th>
                                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                            Type
                                        </th>
                                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                            Superficie (m²)
                                        </th>
                                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                            Nb Pièces
                                        </th>
                                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                            DPE
                                        </th>
                                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                            Actions
                                        </th>
                                    </tr>
                                </thead>
                                <tbody className="bg-white divide-y divide-gray-200">
                                    {biens?.map((bien, index) => (
                                        <tr key={bien.bienId || index} className="hover:bg-gray-50 transition-colors duration-200">
                                          
                                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 font-medium">
                                                {bien.identifiant || <span className="text-gray-400 italic">Non défini</span>}
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                                <div className="flex flex-col">
                                                    <span className="font-medium">
                                                        {bien.adresse || <span className="text-gray-400 italic">Non renseigné</span>}
                                                    </span>
                                                    <span className="text-xs text-gray-500">
                                                        {bien.codePostal}
                                                    </span>
                                                </div>
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">
                                                {bien.ville || <span className="text-gray-400 italic">Non renseigné</span>}
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap">
                                                <span className="inline-flex px-2 py-1 text-xs font-semibold rounded-full bg-blue-100 text-blue-800">
                                                    {bien.type || 'Non défini'}
                                                </span>
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700 text-center">
                                                {bien.superficie || 0} m²
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700 text-center">
                                                {bien.nombreDePieces || 0}
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap text-center">
                                                {bien.classeEnergetique ? (
                                                    <span className={`inline-flex items-center justify-center w-8 h-8 text-xs font-bold rounded-full ${
                                                        bien.classeEnergetique === 'A' ? 'bg-green-500 text-white' :
                                                        bien.classeEnergetique === 'B' ? 'bg-green-400 text-white' :
                                                        bien.classeEnergetique === 'C' ? 'bg-yellow-400 text-white' :
                                                        bien.classeEnergetique === 'D' ? 'bg-yellow-500 text-white' :
                                                        bien.classeEnergetique === 'E' ? 'bg-orange-500 text-white' :
                                                        bien.classeEnergetique === 'F' ? 'bg-red-500 text-white' :
                                                        bien.classeEnergetique === 'G' ? 'bg-red-700 text-white' :
                                                        'bg-gray-200 text-gray-600'
                                                    }`}>
                                                        {bien.classeEnergetique}
                                                    </span>
                                                ) : (
                                                    <span className="text-gray-400 italic text-xs">Non définie</span>
                                                )}
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                                                <div className="relative inline-block text-left">
                                                    <button 
                                                        onClick={(e) => handleMenuClick(e, bien.bienId)}
                                                        className="text-gray-600 hover:text-gray-900 p-2 rounded-full hover:bg-gray-100 transition-colors"
                                                        title="Actions"
                                                    >
                                                        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                                                            <path d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z"/>
                                                        </svg>
                                                    </button>
                                                    
                                                    {menuOpen === bien.bienId && (
                                                        <div className="absolute right-0 mt-2 w-48 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 z-10">
                                                            <div className="py-1">
                                                                <button
                                                                    className="w-full text-left px-4 py-2 text-sm text-green-600 hover:bg-green-50 transition-colors flex items-center"
                                                                    onClick={() => {
                                                                        setMenuOpen(null);
                                                                        handleModifier(bien.bienId);
                                                                    }}
                                                                >
                                                                    <svg className="w-4 h-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                                                                    </svg>
                                                                    Modifier
                                                                </button>
                                                                <button
                                                                    className="w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-red-50 transition-colors flex items-center"
                                                                    onClick={() => {
                                                                        setMenuOpen(null);
                                                                        handleSupprimer(bien.bienId);
                                                                    }}
                                                                >
                                                                    <svg className="w-4 h-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                                                    </svg>
                                                                    Supprimer
                                                                </button>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    ) : (
                        <div className="px-6 py-12 text-center">
                            <div className="text-gray-400 mb-4">
                                <svg className="mx-auto h-12 w-12" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                                </svg>
                            </div>
                            <h3 className="text-lg font-medium text-gray-900 mb-2">Aucun bien trouvé</h3>
                            <p className="text-gray-500">Cliquez sur "Ajouter un bien" pour commencer.</p>
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}
export default Biens;

